import React,{createContext, useState,useContext, useEffect} from "react";
import axios from "axios";
const StarContext =createContext();
// проверка исправления
export const StarProvider=({children})=>{//оборачивает App in index.js
const [mas1, setMas1] = useState([]);
const [mas2, setMas2] = useState([]);
const [sez3, setSez3] = useState([]);
const [sezon1, setSezon1] = useState([]);
const [sezon2, setSezon2] = useState([]);
useEffect(()=>{
    const fetchData = async()=>{
        try {
            // const response = await axios.get("http://localhost:3001/apl/sez3");//get 
             const response = await axios.get("/apl/sez3");//get
            // console.log(response.data.season1);
            console.log('SEZ3:', response.data);
            // setSez3(response.data);
            setSez3(response.data.season1); // исправл12,01,26
        } catch (error) {
            console.error("error in  fetchData in StarContext sez3 fetch", error);
        }
        try{
            const response3 = await axios.get("/api/mas1");//get array [1,2...8]
            console.log(response3.data);
            setMas1(response3.data);
        }
        catch(Error){console.error("ошибка в fetchData in StarContext-response3");
        }
        try{
            const response3 = await axios.get("/api/mas2");//get array [1,2...8]
            console.log(response3.data);
            setMas2(response3.data);
        }
        catch(Error){console.error("ошибка в fetchData in StarContext-response3");
        }
        try {
            const response = await axios.get("/apl/sezon1");
            //http://www.eiforiya.site:3001
            console.log(response.data);
            setSezon1(response.data);
        } catch (error) {
            console.error("error in  fetchData in StarContext sezon1 fetch", error);
        }
        try {
            const response = await axios.get("/apl/sezon2");
            //http://www.eiforiya.site:3001
            console.log(response.data);
            setSezon2(response.data);
        } catch (error) {
            console.error("error in  fetchData in StarContext sezon2 fetch", error);
        }
    };
fetchData();

},[]);
return(
    <StarContext.Provider value={{mas1,mas2,sez3,sezon1,sezon2}}>
        {children}
    </StarContext.Provider>
);

}

export const useStars=()=>{//используется в sidebar.jsx
    const context= useContext(StarContext);
    if(!context){
        throw new Error("ошибка  useContext in StarContext.js");
    }
    return(context);
}